export default __webpack_public_path__ + "static/media/wifi.173d7c8f.svg";